/**
 * Icon Component Renderer
 *
 * Renders icon components with loading state support and flexible data handling.
 *
 * @since 6.9.0 Initial implementation
 */
import { html } from 'lit';
import { spreadProps } from '../utils/spread-props';
/**
 * Allowed props for uo-icon component
 */
const uoIconAllowedProps = new Set([
    'id', // For font icons
    'integration', // For integration icons
    'size',
    'animation',
    'iconStyle',
    'isDuotone',
    'showTooltip'
]);
/**
 * Render an icon component
 *
 * @param {IconData | string | { loading?: boolean; [key: string]: unknown }} data - The icon data to render
 * @param {ComponentProps} [props={}] - Additional props to spread
 *
 * @return {TemplateResult} The rendered icon component
 */
export function iconRenderer(data, props = {}) {
    if (!data) {
        return html ``;
    }
    // Check for loading state from props first, then from data
    const isLoading = props.loading || (typeof data === 'object' && data.loading);
    if (isLoading) {
        // Use the same class and CSS variable as the real icon
        return html `
			<uo-placeholder 
				height="20px"
				width="20px"
			></uo-placeholder>
		`;
    }
    // If iconData is a string, treat it as an integration name
    const iconProps = typeof data === 'string'
        ? { integration: data }
        : data;
    return html `
		<uo-icon ${spreadProps(uoIconAllowedProps)({ ...iconProps, ...props })}></uo-icon>
	`;
}
